import { Box } from "@design-system/Layout/Box";
import { type FC } from "react";
import Loading from "@app/components/Loading";
export { Questionnaires } from "./Questionnaires/index.tsx";
export { Users } from "./Users/index.tsx";
export { Questionnaire } from "./Questionnaires/questionnaire/index.tsx";

export const Sup: FC = () => {
    return (
        <Box>
            <Box className="grid place-items-center h-full">
                <Loading size="large" />
            </Box>
        </Box>
    );
};
